/* Shopping, learning, health (group "You"): shopping research, agentic checkout and try-on
   (SHOP-01..03), the health space (LIFE-01), learning mode and study tools (LIFE-02), finance
   information (LIFE-03), and reminders, lists and life admin (LIFE-04). API: modules/life. */
import { lazy } from 'react';
import { HeartPulse } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'life',
  title: 'Shopping, learning, health',
  short: 'Life',
  icon: HeartPulse,
  group: 'You',
  route: '/life',
  order: 30,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['SHOP-01', 'SHOP-02', 'SHOP-03', 'LIFE-01', 'LIFE-02', 'LIFE-03', 'LIFE-04'],
  commands: [
    { id: 'shop', title: 'Research a product', to: '/life/shop', keywords: ['shopping', 'compare', 'price', 'buy', 'checkout'] },
    { id: 'learn', title: 'Review flashcards', to: '/life/learn', keywords: ['study', 'quiz', 'practice test', 'tutor'] },
    { id: 'health', title: 'Open the health space', to: '/life/health', keywords: ['doctor', 'lab', 'result', 'appointment'] },
    { id: 'finance', title: 'Markets and budget', to: '/life/finance', keywords: ['stocks', 'quotes', 'receipts', 'csv', 'spending'] },
    { id: 'remind', title: 'Add a reminder', to: '/life/admin', keywords: ['reminder', 'list', 'groceries', 'renewal', 'trip'] },
  ],
});
